import {
  GET_CONTENT_SUCCESS, DELETE_CONTENT_REQUEST_SUCCESS
  , CHECK_ALL_CONTENT, CHECK_ONE_CONTENT,
  DELETE_ALL_CONTENT, UNCHECK_ONE_CONTENT,
  UNCHECK_ALL_CONTENT, ADD_CONTENT_REQUEST,
  DELETE_CONTENT_REQUEST, GET_CONTENT_REQUEST,
  ADD_CONTENT,
  GET_CONTENT_FAILED,
  CONTENT_FLAG_OFF,
  SEARCHING,
  SEARCHING_END,
  CONTENT_SCHEDULE_SUCCESS,
  CONTENT_SCHEDULE_DELETE,
  CLIENT_CONTENT_SUCCESS,
  CONTENT_UPDATED,
  COUNT_OF_EACH_CONTENT_REQ,
  COUNT_OF_EACH_CONTENT_SUCCESS,
  GET_FOLDER_CONTENT_REQ,
  GET_FOLDER_CONTENT_SUCCESS,
  UPDATE_CONTENT_PAGE_INCREAMENT,
  UPDATE_CONTENT_PAGE_DECREAMENT,
  GET_PAGINATION_CONTENT_REQ,
  GET_PAGINATION_CONTENT_SUCCESS,
  UPDATE_PAGINATED_CONTENT_PAGE_INCREAMENT,
  UPDATE_PAGINATED_CONTENT_PAGE_DECREAMENT
} from "../constant";

const initial = {
  isContentLoading: false,
  isContentLoaded: false,
  isDeleting: false,
  isDeleted: false,
  isContentAdding: false,
  isContentAdded: false,
  isContentScheduled: false,
  contentLoading:false,
  isContentScheduledDeleted: false,
  content_stats:{},
  content: [],
  userContent:[],
  contentLength:0,
  contentPage:1,
  contentLimit:8,
  paginatedContentLength:0,
  paginatedContentPage:1,
  paginatedContentLimit:20,
  clientContent:[]
};
export const ContentReducer = (state = initial, action) => {
  switch (action.type) {
    case CONTENT_FLAG_OFF:
      return {
        ...state,
        isContentAdded: false,
        isContentScheduled: false,
        isContentScheduledDeleted: false,
        isDeleted: false,
        contentLoading:false,
        // userContent:[],
        // content:[],
        contentLength:0,
        isContentLoaded: false,
      }
      case COUNT_OF_EACH_CONTENT_REQ:
        return {
          ...state,
          contentLoading:true,
        }
      case COUNT_OF_EACH_CONTENT_SUCCESS:
        return {
          ...state,
          contentLoading:false,
          content_stats:action.payload
        }
    case ADD_CONTENT_REQUEST:
      return {
        ...state,
        isContentAdding: true,
      };
    case ADD_CONTENT:
      return {
        ...state,
        isContentAdding: false,
        isContentAdded: true,
        userContent: [...state.userContent, { ...action.payload, checked: false }]
      };
    case GET_CONTENT_REQUEST:
      return {
        ...state,
        isContentLoading: true,
      };
    case GET_CONTENT_SUCCESS:
      let contentArr = [];
      action.payload.forEach((c) => contentArr.push({ ...c, checked: false }));
      return {
        ...state,
        isContentLoading: false,
        content: action.payload,
        isContentLoaded:true,
        paginatedContentLength:state?.content_stats?.total ?? 0
      };
    case GET_CONTENT_FAILED:
      return {
        ...state,
        isContentLoading: false
      }
      case GET_FOLDER_CONTENT_REQ:
        return {
          ...state,
          isContentLoading:true
        }
        case GET_FOLDER_CONTENT_SUCCESS:
          return {
            ...state,
            isContentLoading:false,
            contentLength:action.payload.length,
            userContent:action.payload.content
          }
          case GET_PAGINATION_CONTENT_REQ:
            return {
              ...state,
              isContentLoading:true
            }
            case GET_PAGINATION_CONTENT_SUCCESS:
              return {
                ...state,
                isContentLoading:false,
                isContentLoaded:true,
                paginatedContentLength:action.payload.length,
                content:action.payload.content
              }
          case UPDATE_CONTENT_PAGE_INCREAMENT:
            return {
              ...state,
              contentPage:state.contentPage+1
            }
            case UPDATE_CONTENT_PAGE_DECREAMENT:
              return {
                ...state,
                contentPage:state.contentPage-1
              }
              case UPDATE_PAGINATED_CONTENT_PAGE_INCREAMENT:
                return {
                  ...state,
                  paginatedContentPage:state.paginatedContentPage+1
                }
                case UPDATE_PAGINATED_CONTENT_PAGE_DECREAMENT:
                  return {
                    ...state,
                    paginatedContentPage:state.paginatedContentPage-1
                  }
    case DELETE_CONTENT_REQUEST:
      return {
        ...state,
        isDeleting: true,
      };
    case DELETE_CONTENT_REQUEST_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        isDeleted: true,
        userContent: state.userContent.filter((con) => con.id !== action.payload),
      };
    case CHECK_ALL_CONTENT:
      let checkAllContentArr = [];
      state.content.forEach((c) => checkAllContentArr.push({ ...c, checked: true }));
      return {
        ...state,
        content: checkAllContentArr,
      };
    case UNCHECK_ALL_CONTENT:
      let unCheckAllContentArr = [];
      state.content.forEach((c) => unCheckAllContentArr.push({ ...c, checked: false }));
      return {
        ...state,
        content: unCheckAllContentArr,
      };
    case CHECK_ONE_CONTENT:
      const checkOneContentIndex = state.content.findIndex((c) => c.id === action.payload);
      state.content[checkOneContentIndex] = {
        ...state.content[checkOneContentIndex],
        checked: true,
      };
      return {
        ...state,
        content: state.content,
      };
    case UNCHECK_ONE_CONTENT:
      const unCheckOneContentIndex = state.content.findIndex((c) => c.id === action.payload);
      state.content[unCheckOneContentIndex] = {
        ...state.content[unCheckOneContentIndex],
        checked: false,
      };
      return {
        ...state,
        content: state.content,
      };
    case DELETE_ALL_CONTENT:
      let deleteContentArr = [];
      action.payload.forEach((c) => deleteContentArr.push({ ...c, checked: false }));
      return {
        ...state,
        content: deleteContentArr
      };
    case CONTENT_SCHEDULE_SUCCESS:
      state.content[state.content.findIndex(c => c.id === action.payload._id)] = { ...action.payload };
      return {
        ...state,
        isContentScheduled: true,
        content: state.content
      }
    case CONTENT_SCHEDULE_DELETE:
      state.content[state.content.findIndex(c => c.id === action.payload._id)] = { ...action.payload };
      return {
        ...state,
        isContentScheduledDeleted: true,
        content: state.content
      }
    case CLIENT_CONTENT_SUCCESS:
      return {
        ...state,
        clientContent: action.payload
      }
    case CONTENT_UPDATED:

      const __findIndexForContentUpdate = state.content.findIndex(c => c.id === action.payload.id);
      state.content[__findIndexForContentUpdate] = { ...action.payload };
      return {
        ...state,
        content: state.content
      }
    default:
      return state;
  }
};
